import { useCallback, useState } from 'react';

// Persists per-column pixel widths to localStorage so a resized table keeps
// its layout across reloads. Mirrors the pattern used by the sibling LMS app
// (frontend/src/hooks/useResizableColumns.js) but works with plain <table>
// markup instead of a shared <Table> component.
export default function useColumnWidths(storageKey) {
  const storageId = `pc_col_widths_${storageKey}`;

  const [widths, setWidths] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(storageId) || '{}');
    } catch {
      return {};
    }
  });

  const setWidth = useCallback((id, width) => {
    setWidths(prev => {
      const next = { ...prev, [id]: width };
      try {
        localStorage.setItem(storageId, JSON.stringify(next));
      } catch {
        // localStorage unavailable (private mode, quota) — width just won't persist
      }
      return next;
    });
  }, [storageId]);

  return { widths, setWidth };
}
